import React, { useEffect } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import Header from './components/Header'
import SmoothScroll from './components/SmoothScroll'
import SmoothCursor from './components/SmoothCursor'
import GlobalSearch from './components/GlobalSearch'
import HeaderSearchModal from './components/HeaderSearchModal'
import Home from './pages/Home'
import About from './pages/About'
import Projects from './pages/Projects'
import Services from './pages/Services'
import Connect from './pages/Connect'
import Now from './pages/Now'
import GraphicDesign from './pages/GraphicDesign'
import VideoEditing from './pages/VideoEditing'
import WebsiteDesign from './pages/WebsiteDesign'
import NotFound from './pages/NotFound'
// import AdminDashboard from './components/admin/AdminDashboard'
import { initializeData } from './lib/api.js'

function App() {
  const location = useLocation()
  const isAdminRoute = location.pathname.startsWith('/admin')

  // Initialize default data on app startup
  useEffect(() => {
    initializeData()
  }, [])

  return (
    <SmoothScroll>
      <div className="App">
        <SmoothCursor />
        {!isAdminRoute && <Header />}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/services" element={<Services />} />
          <Route path="/connect" element={<Connect />} />
          <Route path="/now" element={<Now />} />
          <Route path="/graphic-design" element={<GraphicDesign />} />
          <Route path="/video-editing" element={<VideoEditing />} />
          <Route path="/website-design-development" element={<WebsiteDesign />} />
          {/* <Route path="/admin" element={<AdminDashboard />} /> */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        {!isAdminRoute && <GlobalSearch />}
        {!isAdminRoute && <HeaderSearchModal />}
      </div>
    </SmoothScroll>
  )
}

export default App

